import React from 'react';
const NotFound: React.FC<{}>  = () => (
    <div>
        <h1>Not Found</h1>
        <h1>404</h1>
    </div>
);
export default NotFound;
